define('features/overlayGameLauncher/adventureTwo/summary/summaryInit',[
    'underscore'
], function (_) {

    var QUERY_URL = 'thenewadventureprototype/gamification/adventureSummary/',
        COMETD_SUMMARY_XP_PATH = '/thenewadventureprototype/gamification/adventure/xp',
        COMETD_SUMMARY_GEMS_PATH = '/thenewadventureprototype/gamification/adventure/gems';

    function setUpCometdSubscriptions (player, cometd, subscriptionHandlers) {
        cometd.subscribeToPlayer(
                player.id,
                COMETD_SUMMARY_XP_PATH,
                subscriptionHandlers.handleXpUpdate
            );

        cometd.subscribeToPlayer(
                player.id,
                COMETD_SUMMARY_GEMS_PATH,
                subscriptionHandlers.handleGemsUpdate
            );
    }

    return function AdventureTwoSummaryInit (Query,
                                             cometd,
                                             subscriptionHandlers,
                                             adventureTwoObservableData) {
        var self = this;

        self.init = function (player) {

            Query.fromRelativeCommonPath(QUERY_URL + player.id).get().then(function (data) {
                var PAYLOAD_KEYS = ['gems', 'xp'];

                adventureTwoObservableData.property('summary')(_.pick(data, PAYLOAD_KEYS));
            });

            setUpCometdSubscriptions(player, cometd, subscriptionHandlers);

        };
    };

});

